// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1990) return "static/chunks/1990-b4f6d024c534ae56.js";
	if (chunkId === 4786) return "static/chunks/4786-6d39e261ab8eeddc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"797":"541ff11a793ed526","2191":"b004aad6956ea47b","3583":"0d0fec41b6461c9a","8495":"eedc107b2926b219"}[chunkId] + ".js";
};